export default __webpack_public_path__ + "static/media/thrash-black.4149194b.svg";